export default __webpack_public_path__ + "static/media/ADDCART.c8e57451.svg";